// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13Da9","content":"styles_content__qn_Ya"};